import {
  type FrameBuilderPassepartoutState,
  type FrameBuilderProductPassepartout,
} from './types'

/**
 * Determines whether mount color and size are present.
 */
export const getHasPassepartout = (
  passepartout: FrameBuilderProductPassepartout | FrameBuilderPassepartoutState,
) => {
  return (
    typeof passepartout.color !== 'undefined' &&
    typeof passepartout.width !== 'undefined' &&
    typeof passepartout.height !== 'undefined'
  )
}

/**
 * Gets an array with all 4 mount margin sizes.
 */
export const getPassepartoutMarginSizes = (
  passepartout: FrameBuilderProductPassepartout | FrameBuilderPassepartoutState,
) => {
  const hasPassepartout = getHasPassepartout(passepartout)

  if (!hasPassepartout) {
    return [0, 0, 0, 0] as const
  }

  return [
    passepartout.height ?? 0,
    passepartout.width ?? 0,
    passepartout.height ?? 0,
    passepartout.width ?? 0,
  ] as const
}
